import VerificationStatisticCharts from './VerificationStatisticCharts';

export default VerificationStatisticCharts;
